import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, NavLink, Redirect } from "react-router-dom";
import swal from "sweetalert";
import { Base } from "zina-dogi-react";
import { OETBasicInfo, TrackerFilter, TrackerTable } from "../components";
import { RunTable, RunCreatorModal } from "../../run";
import * as oet from "../redux";
import { utils } from "~/utils";
import "./oet_tracker.scss";

const STATUS = ["logistics_oet", "on_run", "closed", "cancelled"];

class OetTracker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            status: null
        };
        this.obit = React.createRef(); // referencia a OETBasicInfo Component
    }

    componentWillMount() {
        const { oetID, getDetails, history } = this.props;
        if (oetID) {
            getDetails(oetID, history);
        }
    }

    render() {
        const { status, oet, loading, extraProps } = this.props;
        const base_op = {
            className: "cpo_tracker",
            title: `OET #${oet ? oet.id_zfill : ""}`,
            breadcrumbs: [
                { name: "Home", rel: "/", icon: "home" },
                {
                    name: `CPO ${oet && oet.cpo_data ? oet.cpo_data.number : ""}`,
                    rel: `/detail/${oet && oet.cpo_data ? oet.cpo_data.id : ""}`
                },
                { name: `OET #${oet ? oet.id_zfill : ""}` }
            ],
            extraProps,
            loading
        };
        console.log(oet && oet.type_flow);

        return (
            <div style={{ height: "100%" }}>
                {!this.props.oetID && this.props.location.pathname !== "/" && <Redirect to="/" />}
                <Base {...base_op}>
                    <TrackerFilter onSubmit={this.onFilter} onCancel={this.onCancel} oet={oet} status={status} />
                    {this.computeTabs(this.props.match.url, status)}
                </Base>
            </div>
        );
    }

    save = data => {
        const { oet, status, history } = this.props;
        switch (status) {
            case 0:
            case 1:
                const { saveLogistic } = this.props;
                saveLogistic(oet.id, data, history);
                break;
            default:
                break;
        }
    };

    updateStatus = status => {
        const { updateSatus, oet, history } = this.props;
        if (oet) {
            updateSatus(oet.id, status, history).catch(error => {
                let errors = [];
                try {
                    const j = JSON.parse(error.response.data.status);
                    if (j.permission) {
                        errors.push(j.permission);
                    }
                    if (j.runs && j.runs.error) {
                        errors.push(j.runs.error);
                    }
                } catch (e) {
                    console.log("error");
                }
                swal({
                    title: "Error",
                    text: errors.length ? errors.join("\n") : utils.computeError(error),
                    icon: "warning",
                    timer: 3000,
                    button: true
                });
            });
        }
    };

    computeTabs = (url, status) => {
        url = url.replace(/\/$/, '');
        const { oet } = this.props;
        let addRunDisabled = true;
        if (oet && oet.status === "logistics_oet") {
            const onRun = oet.available_status_transitions.find(step => step.slug === "on_run");
            addRunDisabled = !onRun.can_change_status;
        } else if (oet && oet.status === "on_run") {
            addRunDisabled = false;
        }
        return (
            <div>
                {this.props.oet && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end"
                        }}
                    >
                        <RunCreatorModal
                            oet={this.props.oet}
                            user={this.props.user}
                            onCreateRun={this.onCreateRun}
                            bypassSubmit={this.props.updateOrderEntryTemplateItem}
                            className="run-creator"
                            disabled={addRunDisabled}
                        />
                    </div>
                )}
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <NavLink exact to={`${url}`} className="nav-link" activeClassName="active">
                            OET Basic Information
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact to={`${url}/table`} className="nav-link" activeClassName="active">
                            CPO Tracker
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact to={`${url}/runs`} className="nav-link" activeClassName="active">
                            Runs
                        </NavLink>
                    </li>
                </ul>
                <div className="tabs">
                    <Switch>
                        <Route
                            exact
                            path={`${url}`}
                            render={props => (
                                <OETBasicInfo
                                    {...props}
                                    onItemsChange={this.onItemsChange}
                                    oet={this.props.oet}
                                    status={status}
                                />
                            )}
                        />
                        <Route
                            exact
                            path={`${url}/table`}
                            render={props => (
                                <TrackerTable
                                    {...props}
                                    onItemsChange={this.onItemsChange}
                                    oet={this.props.oet}
                                    status={status}
                                />
                            )}
                        />
                        <Route
                            exact
                            path={`${url}/runs`}
                            render={props => (
                                <div>
                                    <RunTable
                                        {...props}
                                        onItemsChange={this.onItemsChange}
                                        oet={this.props.oet}
                                        status={status}
                                        history={this.props.history}
                                    />
                                </div>
                            )}
                        />
                        <Redirect to={`${url}`} />
                    </Switch>
                </div>
            </div>
        );
    };

    onFilter = values => {
        this.save(values);
    };

    onCancel = () => {
        this.updateStatus("cancelled");
    };
    onItemsChange = ev => {
        const { oet, history, saveItem } = this.props;
        saveItem(oet.id, ev.newItem, history);
    };

    onCreateRun = ({ item_id, name, type_flow, file=null }) => {
        const { createRun, oetID, history } = this.props;
        let data = null;
        if (file){
            data = new FormData()
            data.append('file', file)
            data.append('oet',oetID)
            data.append('oet_item',item_id)
            data.append('type_flow',type_flow)
        }
        createRun(
            oetID,
            item_id,
            history,
            type_flow,
            run => {
                swal({
                    title: "Successfully created!",
                    text: `Run #${run.number}`,
                    icon: "success",
                    timer: 3000,
                    button: true
                });
            },
            error => {
                utils.show_result_swal(
                    utils.computeError(error),
                    false,
                    'Error'
                )
            },
            data
        );
    };
}

const computeStatus = oet => (oet ? STATUS.indexOf(oet.status) : null);

const mapStateToProps = (store, ownProps) => ({
    user: store.auth.user,
    oet: store.oet.oetSelected,
    status: computeStatus(store.oet.oetSelected),
    oetID: ownProps.match.params.oetID,
    loading: store.oet.loading
});

const mapDispatchToProps = dispatch => ({
    getDetails: (oetID, history) => {
        dispatch(oet.actions.getOetInDetail(oetID, history));
    },
    updateSatus: (oetID, status, history) => {
        return dispatch(oet.actions.changeOETStatus(oetID, status, history));
    },
    saveLogistic: (oetID, body, history) => {
        dispatch(oet.actions.updateLogistic(oetID, body, history));
    },
    saveItem: (oetID, item, history) => {
        dispatch(oet.actions.updateOETItem(oetID, item, history));
    },
    updateOrderEntryTemplateItem: (service, props) => {
        dispatch(oet.actions.executeService(service, props));
    },
    createRun: (oet_id, oet_item, history, type_flow, ok, fail, data) => {
        dispatch(oet.actions.createRun(oet_id, oet_item, history, type_flow, ok, fail, data));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(OetTracker);
